import { useState } from "react";
import { Layers } from "lucide-react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePoll } from "@/hooks/usePoll";
import { api } from "@/lib/api";
import { PageHeader, Panel, Empty } from "@/components/common";
import { CrudActions, AddButton, confirmDelete, FormDialog, TextField, Field } from "@/components/Crud";

export default function SubCategories() {
  const { data, reload } = usePoll("/subcategories", 0);
  const cats = usePoll("/categories", 0).data || [];
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState({ name: "", category_id: "" });
  const [filter, setFilter] = useState("all");

  const openForm = (s) => { setEdit(s || {}); setForm({ name: s?.name || "", category_id: s?.category_id || cats[0]?.id || "" }); };
  const save = async () => {
    if (!form.category_id) throw new Error("Pilih kategori");
    if (edit.id) await api.put(`/subcategories/${edit.id}`, form);
    else await api.post("/subcategories", form);
    toast.success("Sub kategori disimpan");
    reload();
  };
  const catName = (id) => cats.find((c) => c.id === id)?.name || "-";
  const rows = (data || []).filter((s) => filter === "all" || s.category_id === filter);

  return (
    <div>
      <PageHeader title="Sub Kategori Menu" subtitle="Turunan dari kategori, misal Kopi, Non Kopi, Snack">
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-44 bg-white" data-testid="subcategory-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Kategori</SelectItem>
            {cats.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <AddButton testId="add-subcategory-btn" label="Tambah Sub Kategori" onClick={() => openForm()} />
      </PageHeader>
      <Panel>
        {rows.length === 0 ? <Empty icon={Layers} text="Belum ada sub kategori" /> : (
          <Table data-testid="subcategory-table">
            <TableHeader><TableRow><TableHead>Sub Kategori</TableHead><TableHead>Kategori</TableHead><TableHead className="text-right">Aksi</TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.map((s) => (
                <TableRow key={s.id} data-testid={`subcategory-row-${s.id}`}>
                  <TableCell className="font-semibold">{s.name}</TableCell>
                  <TableCell><span className="rounded-full bg-orange-50 px-2.5 py-0.5 text-xs font-semibold text-orange-700">{catName(s.category_id)}</span></TableCell>
                  <TableCell><CrudActions id={`subcategory-${s.id}`} onEdit={() => openForm(s)} onDelete={() => confirmDelete(`/subcategories/${s.id}`, reload, "sub kategori")} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Panel>
      <FormDialog testId="subcategory-form-dialog" open={!!edit} onOpenChange={(o) => !o && setEdit(null)} title={edit?.id ? "Ubah Sub Kategori" : "Tambah Sub Kategori"} onSubmit={save}>
        <Field label="Kategori">
          <Select value={form.category_id} onValueChange={(v) => setForm({ ...form, category_id: v })}>
            <SelectTrigger data-testid="subcategory-category-select"><SelectValue placeholder="Pilih kategori" /></SelectTrigger>
            <SelectContent>{cats.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <TextField label="Nama Sub Kategori" testId="subcategory-name-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
      </FormDialog>
    </div>
  );
}
